export const educationBoardData = {
  "High School": ["CBSE", "ICSE", "State Board"],
  Intermediate: ["CBSE", "ICSE", "State Board"],
  Graduation: ["Bundelkhand University"],
};
